export const myStorage = {
    data: {},
    setItem: (key, value) => {
        myStorage.data[key] = value;
    },
    removeItem: (key) => {
        myStorage.data[key] = null;
    }
};
 